<template>
  <div class="video">
    <template v-if="videoLink && thumbnail">
      <img :src="thumbnail">
      <button v-if="!withoutPlayButton" class="video-play" @click="openPopup($event, 'video')"><i class="icon-play"></i></button>
    </template>
    <AttachmentLoader v-else-if="videoLink && !thumbnail"></AttachmentLoader>
    <transition name="fade">
      <div class="popup-wrapper" v-if="popupVideo">
        <div class="popup-overlay" @click="closePopup('video')"></div>
        <div class="popup popup--video">
          <button class="popup-close2" @click="closePopup('video')"><i class="icon-close"></i> <span>Close player</span></button>
          <div class="video-box">
            <div class="video-wrapper">
              <video width="100%" height="397" controls>
                <source src="images/sample.mp4" type="video/mp4">
              </video>
              <div class="video-img-wrapper" v-html="videoIframe">
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AttachmentLoader from "@/components/forms/AttachmentLoader";
import vimeo from "@/api/external/vimeo";
export default {
props: ['videoLink', 'withoutPlayButton'],
name: "VideoWrapper",
components: {AttachmentLoader},
data() {
  return {
    thumbnail: '',
    popupVideo: false,
    videoIframe: ''
  }
},
mounted() {
  this.getVideoThumbnail()
},
methods: {
  openPopup (e) {
    e.preventDefault()
    this.popupVideo = 1
    document.querySelector('body').classList.add('nooverflow')
  },
  closePopup () {
    this.popupVideo = 0
    document.querySelector('body').classList.remove('nooverflow')
  },
  getVideoThumbnail() {
    let yt_rx = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
    let matches = this.videoLink.match(yt_rx)
    if(matches) {
      this.setYTThumbnail(matches[5])
    }

    let vm_rx = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
    if(this.videoLink.match(vm_rx))      {
      this.setVimeoThumbnail()
    }
  },
  setVimeoThumbnail() {
    vimeo.getThumbnail(this.videoLink, (response) => {
      this.thumbnail = response.thumbnail_url
      this.videoIframe = response.html
    })
  },
  setYTThumbnail(videoId) {
    this.videoIframe = `<iframe id="ytplayer" type="text/html" width="640" height="360"
                           src="https://www.youtube.com/embed/${videoId}?autoplay=1"
                           frameborder="0"/>`
    this.thumbnail = `https://i1.ytimg.com/vi/${videoId}/maxresdefault.jpg`
  }
}
}
</script>

<style scoped>

</style>
